import AboutUs from '../pages/AboutUs';
import { ROUTES } from './routes.config';
 
export const AboutUsRoutes = {
  path: ROUTES.ABOUT_US,
  element: <AboutUs />,
};
